var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
import { TswagClient } from "./../commons/TswagClient";
import { Error as ApiError } from "./../models/V1/Primitives/Error/Error";
import { SearchResult } from "./../models/V1/Companies/Skus/SearchResult";
import { UploadResult } from "./../models/V1/Companies/Skus/UploadResult";
export class CompaniesSkus {
  /**
   * Creates an instance of CompaniesSkus.
   * @param {string} [baseUrl]
   * @param {{ fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }} [http]
   * @memberof CompaniesSkus
   */
  constructor(baseUrl, http) {
    __publicField(this, "http");
    __publicField(this, "baseUrl");
    this.baseUrl = baseUrl;
    this.http = http ? http : window;
  }
  /**
   * @param AddRq_ _addRq
   * @returns Promise<AddRq_>
   * @memberof CompaniesSkus
   */
  add(pAddRq, options = {}) {
    const client = new TswagClient(this.baseUrl + "/api/v1/companies/{companyId}/skus", "POST", "application/json; charset=UTF-8", "text/plain, application/json, text/json", options);
    client.addPathParams([{ name: "companyId", value: pAddRq.companyId, required: true }]);
    client.addBody({ value: pAddRq.body });
    const respDescriptor = {
      headerParams: [],
      items: [
        { statusCode: 201 },
        { statusCode: 400, clazz: ApiError },
        { statusCode: 403, clazz: ApiError },
        { statusCode: 404, clazz: ApiError },
        { statusCode: 409, clazz: ApiError },
        { statusCode: 422, clazz: ApiError }
      ]
    };
    return client.fetch(this.http, respDescriptor);
  }
  /**
   * @param ExportRq_ _exportRq
   * @returns Promise<ExportRq_>
   * @memberof CompaniesSkus
   */
  export(pExportRq, options = {}) {
    const client = new TswagClient(
      this.baseUrl + "/api/v1/companies/{companyId}/skus/export",
      "POST",
      "application/json; charset=UTF-8",
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      options
    );
    client.addPathParams([{ name: "companyId", value: pExportRq.companyId, required: true }]);
    client.addBody({ value: pExportRq.body });
    const respDescriptor = {
      headerParams: [],
      items: [
        { statusCode: 200, isFile: true },
        { statusCode: 403, clazz: ApiError }
      ]
    };
    return client.fetch(this.http, respDescriptor);
  }
  /**
   * @param HasAnyIncompleteRq_ _hasAnyIncompleteRq
   * @returns Promise<HasAnyIncompleteRq_>
   * @memberof CompaniesSkus
   */
  hasAnyIncomplete(pHasAnyIncompleteRq, options = {}) {
    const client = new TswagClient(this.baseUrl + "/api/v1/companies/{companyId}/skus/any", "POST", "application/json; charset=UTF-8", "text/plain, application/json, text/json", options);
    client.addPathParams([{ name: "companyId", value: pHasAnyIncompleteRq.companyId, required: true }]);
    client.addBody({ value: pHasAnyIncompleteRq.body });
    const respDescriptor = {
      headerParams: [],
      items: [{ statusCode: 200 }, { statusCode: 403, clazz: ApiError }, { statusCode: 404, clazz: ApiError }]
    };
    return client.fetch(this.http, respDescriptor);
  }
  /**
   * @param UpdateRq_ _updateRq
   * @returns Promise<UpdateRq_>
   * @memberof CompaniesSkus
   */
  update(pUpdateRq, options = {}) {
    const client = new TswagClient(this.baseUrl + "/api/v1/companies/{companyId}/skus/{id}", "PUT", "application/json; charset=UTF-8", "text/plain, application/json, text/json", options);
    client.addPathParams([
      { name: "companyId", value: pUpdateRq.companyId, required: true },
      { name: "id", value: pUpdateRq.id, required: true }
    ]);
    client.addBody({ value: pUpdateRq.body });
    const respDescriptor = {
      headerParams: [],
      items: [{ statusCode: 204 }, { statusCode: 403, clazz: ApiError }, { statusCode: 404, clazz: ApiError }, { statusCode: 422, clazz: ApiError }]
    };
    return client.fetch(this.http, respDescriptor);
  }
  /**
   * @param RemoveRq_ _removeRq
   * @returns Promise<RemoveRq_>
   * @memberof CompaniesSkus
   */
  remove(pRemoveRq, options = {}) {
    const client = new TswagClient(this.baseUrl + "/api/v1/companies/{companyId}/skus/{id}", "DELETE", "application/json; charset=UTF-8", "text/plain, application/json, text/json", options);
    client.addPathParams([
      { name: "companyId", value: pRemoveRq.companyId, required: true },
      { name: "id", value: pRemoveRq.id, required: true }
    ]);
    const respDescriptor = {
      headerParams: [],
      items: [{ statusCode: 204 }, { statusCode: 403, clazz: ApiError }, { statusCode: 404, clazz: ApiError }]
    };
    return client.fetch(this.http, respDescriptor);
  }
  /**
   * @param SearchRq_ _searchRq
   * @returns Promise<SearchRq_>
   * @memberof CompaniesSkus
   */
  search(pSearchRq, options = {}) {
    const client = new TswagClient(this.baseUrl + "/api/v1/companies/{companyId}/skus/search", "POST", "application/json; charset=UTF-8", "text/plain, application/json, text/json", options);
    client.addPathParams([{ name: "companyId", value: pSearchRq.companyId, required: true }]);
    client.addBody({ value: pSearchRq.body });
    const respDescriptor = {
      headerParams: [],
      items: [
        { statusCode: 200, clazz: SearchResult },
        { statusCode: 400, clazz: ApiError },
        { statusCode: 403, clazz: ApiError },
        { statusCode: 404, clazz: ApiError }
      ]
    };
    return client.fetch(this.http, respDescriptor);
  }
  /**
   * @param UploadRq_ _uploadRq
   * @returns Promise<UploadRq_>
   * @memberof CompaniesSkus
   */
  upload(pUploadRq, options = {}) {
    const client = new TswagClient(this.baseUrl + "/api/v1/companies/{companyId}/skus/upload", "POST", "multipart/form-data", "text/plain, application/json, text/json", options);
    client.addPathParams([{ name: "companyId", value: pUploadRq.companyId, required: true }]);
    client.addFormData("multipart/form-data", [{ name: "file", value: pUploadRq.file }]);
    const respDescriptor = {
      headerParams: [],
      items: [
        { statusCode: 200, clazz: UploadResult },
        { statusCode: 403, clazz: ApiError },
        { statusCode: 409, clazz: ApiError }
      ]
    };
    return client.fetch(this.http, respDescriptor);
  }
}
